const STATS = [
  { value: "10+", label: "影视作品" },
  { value: "6", label: "明星动态" },
  { value: "4", label: "题材类型" },
  { value: "8.3", label: "平均评分" },
];

export default function HomeIntro() {
  return (
    <section className="px-5 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)] gap-10 lg:gap-16 items-center">
        <div>
          <span className="text-xs font-medium tracking-[0.2em] uppercase text-accent-600">
            About The Brand
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mt-3 mb-5 leading-tight">
            佐山爱影视作品与明星动态门户
          </h1>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            这里汇集了佐山爱出道以来的全部影视作品档案与最新明星动态。
            从银幕之上的光影故事，到镜头之外的采访与活动，
            我们希望为每一位影迷提供一个清晰、完整、舒适的浏览入口。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            无论你是想重温一部经典作品，还是想第一时间了解她的新片资讯，
            都可以在这里找到答案。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-5">
          {STATS.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col justify-center p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70"
            >
              <span className="font-heading font-bold text-3xl md:text-4xl text-primary-600 mb-1">
                {stat.value}
              </span>
              <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}